const actionTypes = {
    // STEP ACTUAL POSITION
    SET_STEP_ACTUAL_POSITION: 'SET_STEP_ACTUAL_POSITION',
};

export { actionTypes }